import React, { FC } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import { CustomSpinner } from '../../shared/Spinner';
import { useHomepageAllQuery } from '../home/query';
import { CategoriesGrid } from '../../components/CategoriesGrid';
import styles from '../movies/MoviesPage.module.scss';

const CategoriesPage: FC = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  // GET CATEGORIES DATA
  const { homePage, isLoading: isHomepageLoading } = useHomepageAllQuery(false);

  if (isHomepageLoading) {
    return (
      <Container className={styles.mainWrapper}>
        <CustomSpinner />
      </Container>
    );
  }

  if (!homePage?.data?.categories) {
    return (
      <Container className={styles.mainWrapper}>
        <Row>
          <Col xs={12}>
            <div className={styles.title}>
              <h2>Kategorien</h2>
            </div>
            <p>Keine Kategorien verfügbar.</p>
          </Col>
        </Row>
      </Container>
    );
  }

  // Filter out adult categories for non-authenticated users
  const filteredCategories = homePage.data.categories.filter(category => 
    !category.name.toLowerCase().includes('erotik')
  );

  return (
    <Container className={styles.mainWrapper}>
      <Row>
        <Col xs={12}>
          <div className={styles.title}>
            <h2>Kategorien</h2>
          </div>
        </Col>
      </Row>
      <CategoriesGrid categories={filteredCategories} forceKategorienRoute={true} />
    </Container>
  );
};

export default CategoriesPage;